import React from "react";
import { Link } from "react-router-dom";

export default function Coursecard({ course }) {

  // Master courses
  const masterCourses = ["MA", "MBA", "MCA", "MCom", "MSc"];

  // Check course type
  const isMaster = masterCourses.includes(course.title);

  // Check MBA or MCA
  const isMBAorMCA =
    course.title === "MBA" || course.title === "MCA";


  return (

    <div
      className="bg-white overflow-hidden h-100 d-flex flex-column"
      style={{
        borderRadius: "25px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
        width: "calc(100% + 8px)",
        marginLeft: "-4px",
      }}
    >

      {/* TOP AREA */}
      <div
        className="position-relative d-flex flex-column align-items-center justify-content-center"
        style={{
          background: course.color,
          height: "190px",
          padding: "20px",
        }}
      >

        {/* UNIVERSITY LOGO */}
        <img
          src={course.image}
          alt={course.universityName}
          style={{
            width: "90px",
            height: "90px",
            objectFit: "contain",
          }}
        />


        {/* UNIVERSITY NAME */}
        <h6
          className="text-center fw-bold mt-2 mb-0"
          style={{
            color: "#fff",
            fontSize: "14px",
          }}
        >

          {course.universityName}

        </h6>


        {/* NUMBER BADGE */}
        <div
          className="position-absolute"
          style={{
            width: "65px",
            height: "65px",
            borderRadius: "50%",
            background: "#FFD600",
            bottom: "-30px",
            left: "25px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "700",
            fontSize: "24px",
          }}
        >

          {course.id}

        </div>

      </div>


      {/* CARD BODY */}
      <div className="p-4 pt-5 text-center d-flex flex-column flex-grow-1">

        {/* COURSE TITLE */}
        <h3
          className="fw-bold"
          style={{
            fontSize: "24px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >

          {course.title}

        </h3>


        {/* PRICE */}
        <h4
          className="mt-3 fw-bold mb-3"
          style={{
            color: course.color,
          }}
        >

          {course.price}

        </h4>


        {/* COURSE DETAILS */}
        <div
          style={{
            textAlign: "left",
            fontSize: "14px",
            lineHeight: "1.6",
            marginBottom: "25px",
          }}
        >

          {isMaster ? (

            <>
              <p className="mb-2">

                • <b>Duration:</b> 2 Years

              </p>


              <p className="mb-2">

                • <b>Mode of Study:</b> Online

              </p>


              <p className="mb-2">

                • <b>Eligibility:</b>{" "}

                {isMBAorMCA
                  ? "10 + 2 + Graduation with 50% Marks"
                  : "10 + 2 + Graduation with 35% Marks"}

              </p>


              <p className="mb-2">

                • <b>Type of Degree:</b> Physical (UGC Recognised) Degree

              </p>

            </>

          ) : (

            <>

              <p className="mb-2">

                • <b>Duration:</b> 3 Years

              </p>


              <p className="mb-2">

                • <b>Mode of Study:</b> Online

              </p>


              <p className="mb-2">

                • <b>Eligibility:</b> 10 + 2 or Class X + 3 Years Diploma
                (or 2 Year ITI Diploma with 1 year NTC)

              </p>


              <p className="mb-2">

                • <b>Type of Degree:</b> Physical (UGC Recognised) Degree

              </p>

            </>

          )}

        </div>


        {/* BUTTON */}
        <div className="mt-auto">

          <Link
            to="/contact#contact-form"
            className="btn w-100 text-white"
            style={{
              background: course.color,
              height: "50px",
              borderRadius: "12px",
              fontWeight: "600",
              fontSize: "17px",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
            }}
          >

            Enquire Now →

          </Link>

        </div>

      </div>

    </div>

  );

}